import { useEffect, useState } from 'react';
import GridProvider from './components/GridProvider';
import { useTranslation } from 'react-i18next';

import NewDocumentForm from './components/NewDocumentForm';
import MuiDialog from '../../../../../../UI/MuiDialog/MuiDialog';
import useHttp from '../../../../../../../hooks/use-http';
import { urls } from './api/urls';
import toast from 'react-hot-toast';
import { handleErrorMessage } from '../../../../../../../../shared/api/handleErrorMessage';
import { formatDateToDB } from '../../../../../../../../utils/FormatDate';
import styles from './Documents.module.css';

const INITIAL_VALUES = {
  nazivFajla: '',
  nazivJezika: '',
  idJezika: 0,
  nazivGlavnaKategorija: '',
  idGlavnaKategorija: 0,
  nazivKategorije: '',
};

const Documents = ({ idMasine }) => {
  const { t, i18n } = useTranslation();

  const {
    sendRequest: getGridData,
    data: gridData,
    isLoading: isLoadingGrid,
  } = useHttp('');
  const { sendRequest: getJezik, data: languageData } = useHttp('');
  const { sendRequest: getGlavnaKategorija, data: mainCategoryData } =
    useHttp('');
  const { getData } = useHttp('');

  const [openDocument, setOpenDocument] = useState(false);
  const [openNewDocument, setOpenNewDocument] = useState(false);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);

  const [documentId, setDocumentId] = useState(0);
  const [formData, setFormData] = useState(INITIAL_VALUES);
  const [file, setFile] = useState([]);
  const [openPath, setOpenPath] = useState(null);

  const vratiGrid = () => {
    const config = {
      method: 'POST',
      url: urls.GET_DOKUMENTA,
      data: {
        idObjekta: idMasine,
        objekat: 'mas',
        metadata: i18n.language,
      },
    };
    getGridData(config);
  };

  useEffect(() => {
    const config = {
      url: urls.GET_JEZIK,
    };
    getJezik(config);
    const configMainCategory = {
      url: urls.GET_MAIN_CATEGORY,
    };
    getGlavnaKategorija(configMainCategory);

    vratiGrid();
  }, []);

  const handleOpenFile = (item) => {
    setOpenPath(item.path);
    setOpenDocument(true);
  };
  const handleOpenNewDocument = () => {
    setOpenNewDocument(true);
  };
  const handleNovi = () => {
    setFormData(INITIAL_VALUES);
    setFile([]);
  };
  const handleSave = async () => {
    const fd = new FormData();
    fd.append('IdVrsteDokOpste', formData.idGlavnaKategorija);
    fd.append('objekat', 'mas');
    fd.append('IdObjekta', idMasine);
    fd.append('NazivFajla', formData.nazivFajla);
    fd.append('IdJezika', formData.idJezika);
    fd.append('Kategorija', formData.nazivKategorije);
    fd.append('Datum', formatDateToDB(new Date()));
    if (file.length > 0) {
      fd.append('Dokumenti', file[0]);
    }
    const config = {
      method: 'POST',
      url: urls.INSERT_DOKUMENTA,
      data: fd,
    };
    const result = await getData(config);
    if (result) {
      handleNovi();
      setOpenNewDocument(false);
      vratiGrid();
      return;
    }
    toast.error(handleErrorMessage(result));
  };

  const handleOpenDeleteDialog = (id) => {
    setOpenDeleteDialog(true);
    setDocumentId(id);
  };
  const handleDelete = async () => {
    const config = {
      method: 'POST',
      url: urls.DELETE_DOKUMENT,
      data: { id: documentId },
    };
    const result = await getData(config);
    if (result) {
      setDocumentId(0);
      setOpenDeleteDialog(false);
      vratiGrid();
      return;
    }
    toast.error(handleErrorMessage(result));
  };
  const downloadFile = async (fileUrl, fileName) => {
    const config = {
      method: 'POST',
      url: 'Dokumenta/konvertovanje_base64',
      data: { vrednost: fileUrl },
    };

    const response = await getData(config);

    const base64Data = response; // Pretpostavljam da response.data sadrži base64 string.

    // Konvertovanje base64 stringa u Blob objekt
    const byteCharacters = atob(base64Data);
    const byteNumbers = Array.from(byteCharacters, (char) =>
      char.charCodeAt(0),
    );
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: 'application/octet-stream' });

    // Kreiranje URL-a za Blob objekt
    const blobUrl = URL.createObjectURL(blob);

    // Kreiranje i klikanje na link element za preuzimanje datoteke
    const link = document.createElement('a');
    link.href = blobUrl;
    link.setAttribute('download', fileName); // Postavite naziv datoteke
    document.body.appendChild(link);
    link.click();

    // Čišćenje URL-a i uklanjanje linka
    URL.revokeObjectURL(blobUrl);
    document.body.removeChild(link);
  };
  return (
    <div>
      <div
        style={{ cursor: 'pointer', width: 'fit-content' }}
        onClick={handleOpenNewDocument}
      >
        <i className="fas fa-plus-circle" /> {t('newDocument')}
      </div>
      <GridProvider
        data={gridData}
        loading={isLoadingGrid}
        handleOpenFile={handleOpenFile}
        handleOpenDeleteDialog={handleOpenDeleteDialog}
        downloadFile={downloadFile}
      />
      <MuiDialog
        maxWidth="md"
        open={openDocument}
        title="DOCUMENT"
        content={
          <iframe
            className={styles.fileContainer}
            src={openPath}
            title="File"
          />
        }
        handleClose={() => setOpenDocument(false)}
        deniedText="ZATVORI"
      />
      <MuiDialog
        maxWidth="sm"
        open={openNewDocument}
        title={t('newDocument')}
        content={
          <NewDocumentForm
            formData={formData}
            setFormData={setFormData}
            languageData={languageData}
            mainCategoryData={mainCategoryData}
            setFile={setFile}
            file={file}
          />
        }
        handleClose={() => setOpenNewDocument(false)}
        handleConfirm={handleSave}
        deniedText={t('close')}
      />
      <MuiDialog
        maxWidth="sm"
        open={openDeleteDialog}
        title={t('warning')}
        text={t('warningDelete')}
        handleClose={() => setOpenDeleteDialog(false)}
        handleConfirm={handleDelete}
        deniedText="ZATVORI"
      />
    </div>
  );
};

export default Documents;
